'use strict';

var GridCopySpecialEventButtonController = function GridCopySpecialEventButtonController($scope, specialEventsGridService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isCopySpecialEventShow = false;
  $scope.selectedRows = [];
  function eventValidForCopy(selectedRow) {
    return !specialEventsGridService.isUserExclusionEvent(selectedRow) && selectedRow.isRowEditable;
  }
  $scope.onRowSelection = function (selectedRows) {
    $scope.isCopySpecialEventShow = selectedRows.length === 1 && eventValidForCopy(selectedRows[0]);
    $scope.selectedRows = selectedRows;
  };
  $scope.copySpecialEvent = function () {
    specialEventsGridService.duplicateRow(gridPanel, $scope.selectedRows[0]);
  };
};
GridCopySpecialEventButtonController.$inject = ['$scope', 'SpecialEventsGridService'];
module.exports = GridCopySpecialEventButtonController;